import AmplifyButton from '@amplify/amplify-button';
import clsx from 'clsx';
import { CSSProperties } from 'react';

import k5DefaultImg from 'src/assets/images/k5-default-card-img.svg';
import { Theme } from 'src/interfaces/theme.types';
import { getImagePath } from 'src/utils/url.utils';

import './k5-card-image.scss';

type K5CardImageProps = {
  theme: Theme;
  imagePath?: string;
  classNames?: {
    containerClassnames?: string;
    imageClassnames?: string;
  };
  withCheckmark?: boolean;
  shouldConstructImagePath?: boolean;
};

export const K5CardImage = ({
  theme,
  imagePath,
  classNames,
  withCheckmark,
  shouldConstructImagePath = true,
}: K5CardImageProps) => {
  const getBackgroundImageStyles = () => {
    if (!imagePath) {
      return `url("${k5DefaultImg}")`;
    }

    if (shouldConstructImagePath) {
      return `url("${getImagePath(imagePath)}")`;
    }

    return `url("${imagePath}")`;
  };

  const imageStyles = {
    '--assignment-image-border': 'var(--new-assignment-image-border)',
    backgroundImage: getBackgroundImageStyles(),
  } as CSSProperties;

  return (
    <div
      className={clsx(
        'k5-card-image__container',
        classNames?.containerClassnames,
      )}
    >
      <div
        className={clsx(
          'k5-card-image',
          `k5-card-image-${theme}`,
          classNames?.imageClassnames,
          {
            'k5-card-image--greyed-out': withCheckmark,
          },
        )}
        style={imageStyles}
      />
      {withCheckmark && (
        <div className="theme-k5 layout-context-delta k5-card-image__checkmark">
          <AmplifyButton
            variant="secondary"
            className="btn-icon type-scale-2"
            icon="icon-k5-checkmark"
            oval
          />
        </div>
      )}
    </div>
  );
};
